import { createSlice } from "@reduxjs/toolkit";
import { formatDate } from "../../components/Ag-Grid/src/editor/NoteCellEditor";

const initialState = {
  text: "",
};

export const loggerSlice = createSlice({
  name: "logger",
  initialState,
  reducers: {
    setLogger: (state, action) => {
      state.text = `${formatDate(Date.now())} - ${action.payload}`;
    },
    clearLogger: (state) => {
      state.text = "";
    },
  },
});

export const { setLogger, clearLogger } = loggerSlice.actions;
export default loggerSlice.reducer;
